import React from "react";
import { Folder as FolderIcon } from "@mui/icons-material";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import TooltipComponent from "./tooltipComponent";
import notAvailable from "../assets/images/notAvalaible.svg";
import "../styles/MaterialFolder.scss";

const MaterialFolderGrid = ({ folders = [], onOpen }) => {
  if (!folders || folders.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img
          src={notAvailable}
          alt="PowerPoint Icon"
          style={{ width: "300px", height: "300px", marginTop: "4px" }}
        />
        <h3 className="material-folder-empty">No materials available.</h3>
      </div>
    );
  }

  return (
    <div className="material-folder-grid">
      {folders.map((folder) => {
        const hasDocument = folder.hasDocument || false;
        const isMaterial =
          folder._kind === "material" ||
          folder.kind === "material" ||
          folder._kind === "institution_material";
        return (
          <div
            key={folder.id || folder.key}
            className={`material-folder-item ${
              isMaterial ? "material-type" : ""
            }`}
            onClick={() => onOpen && onOpen(folder)}
          >
            <div className="folder-icon-container">
              <FolderIcon
                className={`material-folder-icon ${
                  isMaterial ? "material-folder" : "regular-folder"
                }`}
              />
              {hasDocument && (
                <div className="document-icon-overlay">
                  <InsertDriveFileIcon className="document-icon" />
                </div>
              )}
            </div>

            <TooltipComponent className="folder-name">
              {folder.title || folder.name}
            </TooltipComponent>
          </div>
        );
      })}
    </div>
  );
};

export default MaterialFolderGrid;
